/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgxSyncScrollComponent as ɵa} from './lib/ngx-syncscroll/ngx-syncscroll.component';